<mat-card layout="column">
  <mat-card-content>
    <div class="alc-margin-10 alc-text alc-bm-name business-manager-line">
      <span> {{ business.name }}</span>
      <button mat-button (click)="confirmThenDeleteBusinessManager()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div class="alc-spinner-wrapper" *ngIf="isQueryOngoing">
      <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
    <div class="alc-margin-10 alc-text" layout="row">
      <span class="alc-bm-info-label">{{ 'business-manager/external_id' | translate }}</span
      >{{ business.external_id }}
    </div>
    <div class="alc-margin-10 alc-text" layout="row">
      <span class="alc-bm-info-label">{{ 'business-manager/url' | translate }}</span>
      <a class="margin-left-5" href="{{ business.linkToBusinessManager }}">{{ business.linkToBusinessManager }}</a>
    </div>
    <div class="alc-margin-10 alc-text" layout="row">
      <span class="alc-bm-info-label">{{ 'business-manager/connected_at' | translate }} </span
      >{{ business.connected_at | dateTimezone: 'short' }}
      <span class="alc-bm-info-label margin-left-5"> {{ 'business-manager/connected_by' | translate }} </span
      >{{ business.connected_by }}
    </div>
  </mat-card-content>
  <mat-divider class="alc-divider-margin-16"></mat-divider>
  <mat-card-content class="alc-cart-content-middle">
    <div class="alc-margin-10 alc-text alc-bold">
      {{ 'business-manager/connected-catalogs' | translate }}
      <app-catalog
        *ngFor="let catalog of business.catalogs"
        [catalog]="catalog"
        [businessId]="business.id"></app-catalog>
    </div>
  </mat-card-content>
  <mat-card-content>
    <div class="alc-margin-10 alc-text alc-bold">
      <a class="connect-catalog" (click)="addCatalog()">
        {{ 'menu/settings/add-catalog' | translate }}
      </a>
    </div>
  </mat-card-content>
</mat-card>
